const PhotoSwipe = window.PhotoSwipe
const PhotoSwipeLightbox = window.PhotoSwipeLightbox

export class ProductUpsellPhotoSwipe extends window.BAO.CustomElement {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.link?.exists) return

    this.initializePhotoSwipeInstance()
  }

  initializePhotoSwipeInstance () {
    // Destroy existing instance if any
    if (this.photoSwipeInstance) {
      this.photoSwipeInstance.destroy()
      this.photoSwipeInstance = null
    }

    this.photoSwipeInstance = new PhotoSwipeLightbox({
      loop: true,
      showAnimationDuration: 500,
      scaleMode: 'zoom',

      gallery: this.localName,
      children: '[data-product-upsell-photoswipe-el="link"]',
      bgOpacity: 1,
      arrowPrev: false,
      arrowNext: false,
      zoom: false,
      close: false,
      counter: false,
      preloadFirstSlide: true,
      preload: [1, 4],

      closeOnVerticalDrag: true,

      tapAction: 'zoom',

      pswpModule: () => {
        return PhotoSwipe
      },
    })

    this.setupPhotoSwipeListeners()
    this.photoSwipeInstance.init()
  }

  setupPhotoSwipeListeners () {
    const self = this
    this.photoSwipeInstance.on('uiRegister', function () {
      // 'this' refers to the PhotoSwipe instance (pswp)
      const pswp = this
      self.addPreviousButton(pswp)
      self.addNextButton(pswp)
      self.addCloseButton(pswp)
      self.addThumbnails(pswp)
    })
  }

  addPreviousButton (pswp) {
    pswp.ui.registerElement({
      name: 'custom-prev',
      className: 'pswp-Action_Arrow pswp-Action_Arrow-previous',
      ariaLabel: 'Previous',
      order: 1,
      isButton: true,
      html: this.arrowSvg,
      onClick: () => {
        pswp.prev()
      },
    })
  }

  addNextButton (pswp) {
    pswp.ui.registerElement({
      name: 'custom-next',
      className: 'pswp-Action_Arrow pswp-Action_Arrow-next',
      ariaLabel: 'Next',
      order: 3,
      isButton: true,
      html: this.arrowSvg,
      onClick: () => {
        pswp.next()
      },
    })
  }

  addCloseButton (pswp) {
    pswp.ui.registerElement({
      name: 'custom-close',
      className: 'pswp-Action_Close',
      ariaLabel: 'Close',
      order: 2,
      isButton: true,
      html: this.closeSvg,
      onClick: () => {
        pswp.close()
      },
    })
  }

  addThumbnails (pswp) {
    pswp.ui.registerElement({
      name: 'thumbnails',
      className: 'pswp-Action_Dots',
      appendTo: 'wrapper',
      onInit: (element, pswpInstance) => {
        const thumbEls = []
        let previousIndex = -1

        // Get all the link elements with the data attribute
        const galleryElements = this.querySelectorAll(
          '[data-product-upsell-photoswipe-el="link"]'
        )

        for (let i = 0; i < pswpInstance.getNumItems(); i++) {
          const thumbEl = document.createElement('button')
          thumbEl.type = 'button'
          thumbEl.className = 'pswp-Action_Dot'
          thumbEl.onclick = () => {
            pswpInstance.goTo(i)
          }

          // Create the img element for the thumbnail
          const imgEl = document.createElement('img')
          imgEl.className = 'pswp-Action_DotImage'

          // Get the thumbnail image URL from data-thumb-image attribute
          const thumbUrl = galleryElements[i].getAttribute('data-thumb-image')
          imgEl.src = thumbUrl

          // Append the img to the button
          thumbEl.appendChild(imgEl)

          // Append the button to the thumbnails container
          element.appendChild(thumbEl)

          // Store the thumbnail element for later use
          thumbEls.push(thumbEl)
        }

        // Update the aria-current attribute on change
        pswpInstance.on('change', () => {
          if (previousIndex >= 0) {
            thumbEls[previousIndex].setAttribute('aria-current', 'false')
          }
          thumbEls[pswpInstance.currIndex].setAttribute('aria-current', 'true')
          previousIndex = pswpInstance.currIndex
        })
      },
    })
  }

  get arrowSvg () {
    return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 5 8">
      <path fill="currentColor" d="M4.036 4.035a.5.5 0 0 0 0-.707L.854.146a.5.5 0 1 0-.708.707L2.975 3.68.146 6.51a.5.5 0 1 0 .708.707l3.182-3.182Zm-1.354.146h1v-1h-1v1Z"/>
    </svg>`
  }

  get closeSvg () {
    return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22">
      <path fill="currentColor" d="m4.282 3.575 14.143 14.142-.708.707L3.575 4.282z"/><path fill="currentColor" d="M3.575 17.718 17.718 3.576l.707.707L4.283 18.425z"/></svg>`
  }
}

if (!customElements.get('product-upsell-photoswipe')) {
  customElements.define('product-upsell-photoswipe', ProductUpsellPhotoSwipe)
}
